<template>
    <v-app>
        <v-main style="background-color: #f5f6f8;">
            <div class="driver-shell">
                <slot/>
            </div>
        </v-main>
    </v-app>
</template>

<script setup>
</script>

<style scoped>
/* Mobile-first: a narrow, centred column that reads well on a phone and stays
   comfortable on a desktop browser too. */
.driver-shell {
    max-width: 560px;
    margin: 0 auto;
    min-height: 100vh;
}
</style>
